const challenges = 'challenges-page-challenges';

const queryKeyFactory = {
  challenges: ({ challengeFilter }) => {
    return [challenges, { challengeFilter }];
  },
};

export default queryKeyFactory;
